import { render, staticRenderFns } from "./VideoConsult.vue?vue&type=template&id=3a2efdcf"
import script from "./VideoConsult.vue?vue&type=script&lang=js"
export * from "./VideoConsult.vue?vue&type=script&lang=js"
import style0 from "./VideoConsult.vue?vue&type=style&index=0&id=3a2efdcf&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports